import { getData, postData } from './apiService';
import { TwoFactorSetup, TwoFactorStatus } from '../types/auth';

interface BackupCodesResponse {
  backupCodes: string[];
}


class TwoFactorService {
  /**
   * Get 2FA status for current user
   */
  async getTwoFactorStatus(): Promise<TwoFactorStatus> {
    const response = await getData('/api/2fa/status');
    if (response.status !== 'success') {
      throw new Error(response.message || 'Failed to get 2FA status');
    }
    return response.data;
  }

  /**
   * Setup 2FA - get QR code and setup data
   */
  async setupTwoFactor(): Promise<TwoFactorSetup> {
    const response = await postData('/api/2fa/setup', {});
    if (response.status !== 'success') {
      throw new Error(response.message || 'Failed to setup 2FA');
    }
    return response.data;
  }

  /**
   * Enable 2FA with verification token
   */
  async enableTwoFactor(secret: string, token: string): Promise<BackupCodesResponse> {
    const response = await postData('/api/2fa/enable', {
      secret,
      token
    });
    if (response.status !== 'success') {
      throw new Error(response.message || 'Failed to enable 2FA');
    }
    return response.data;
  }

  /**
   * Disable 2FA
   */
  async disableTwoFactor(currentPassword: string): Promise<void> {
    const response = await postData('/api/2fa/disable', {
      currentPassword
    });
    if (response.status !== 'success') {
      throw new Error(response.message || 'Failed to disable 2FA');
    }
  }

  /**
   * Regenerate backup codes
   */
  async regenerateBackupCodes(token: string): Promise<BackupCodesResponse> {
    const response = await postData('/api/2fa/regenerate-codes', {
      token
    });
    if (response.status !== 'success') {
      throw new Error(response.message || 'Failed to regenerate backup codes');
    }
    return response.data;
  }
}

export const twoFactorService = new TwoFactorService();
export default twoFactorService;